"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePriceRange = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _shoppingContext = require("@ori/shopping-context");
var _models = require("../models");
var _utils = require("../utils");
const usePriceRange = ({
  isHomeDelivery,
  lastDeliveryItemMethod,
  lastDeliveryItemFee
}) => {
  const sessionId = (0, _shoppingContext.useSessionId)();
  const {
    data,
    isValidating: isLoadingDeliveryMethods
  } = (0, _globalApiClientReact.useGetShoppingSessionDeliveryMethods)(sessionId);
  if (isLoadingDeliveryMethods || !data) {
    return {
      minFee: undefined,
      maxFee: undefined
    };
  }
  const deliveryMethods = data.collection;
  if (isHomeDelivery) {
    const lastHomeDeliveryFee = lastDeliveryItemMethod === _models.AddressItemDeliveryMethod.Home ? lastDeliveryItemFee : undefined;
    return (0, _utils.getHomeDeliveryFeeRange)(deliveryMethods, lastHomeDeliveryFee);
  }
  const lastPickupPointDeliveryFee = lastDeliveryItemMethod === _models.AddressItemDeliveryMethod.Home ? undefined : lastDeliveryItemFee;
  return (0, _utils.getPickupPointsFeeRange)(deliveryMethods, lastPickupPointDeliveryFee);
};
exports.usePriceRange = usePriceRange;